import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { GapStylingConfig } from './types';

interface ActionButtonsProps {
  config: GapStylingConfig;
  onConfigChange: (config: GapStylingConfig) => void;
  onSave?: (config: GapStylingConfig) => Promise<void>;
  saving: boolean;
  defaultConfig: GapStylingConfig;
}

/**
 * Action buttons component for gap styling configuration
 * Provides save and reset functionality with loading states
 */
const ActionButtons: React.FC<ActionButtonsProps> = ({
  config,
  onConfigChange,
  onSave,
  saving,
  defaultConfig
}) => {
  const handleSave = async () => {
    if (!onSave) return;

    try {
      await onSave(config);
    } catch (error) {
      // Error handling is done in the parent component
      console.error('Save failed:', error);
    }
  };

  return (
    <Box mt={2} display="flex" gap={2} flexWrap="wrap">
      {onSave && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} /> : <SaveIcon />}
        >
          {saving ? 'Saving...' : 'Save Configuration'}
        </Button>
      )}
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => onConfigChange(defaultConfig)}
        disabled={saving}
      >
        Reset to Default
      </Button>
    </Box>
  );
};

export default ActionButtons;